<template>
	<div class="brand-inner">
		<div class="brand-inner__cover">
			<div class="img-box">
				<BreadCrumb />
				<picture>
					<source media="(max-width: 767px)" :srcset="
						_.get(contentData, 'data.list[0].mobile_cover_image[0].devices.mobile')
							? _.get(contentData, 'data.list[0].mobile_cover_image[0].devices.mobile')
							: _.get(contentData, 'data.list[0].cover_image[0].devices.mobile')
					" />
					<source media="(max-width: 1023px)"
						:srcset="_.get(contentData, 'data.list[0].cover_image[0].devices.tablet')" />
					<img :src="_.get(contentData, 'data.list[0].cover_image[0].devices.desktop')" alt />
				</picture>
			</div>

			<div class="layer"></div>
			<div class="bottom-content container">
				<div class="logo">
					<div class="brand-logo">
						<svg xmlns="http://www.w3.org/2000/svg" width="122.998" height="158.021"
							viewBox="0 0 122.998 158.021">
							<g id="Group_6333" data-name="Group 6333" transform="translate(-228.001 -482.979)">
								<g id="Group_5773" data-name="Group 5773">
									<path id="Union_2" data-name="Union 2"
										d="M-628,10925.521v-90h32.07v-7.6a29.458,29.458,0,0,1,29.424-29.424,29.458,29.458,0,0,1,29.427,29.424v7.6H-505v90Zm79.462-90v-7.6a17.989,17.989,0,0,0-17.968-17.965,17.988,17.988,0,0,0-17.965,17.965v7.6Z"
										transform="translate(856 -10315.521)" fill="#f7f7f7" opacity="0.6" />
								</g>
								<g id="Group_5782" data-name="Group 5782" transform="translate(-2317.995 11181.264)">
									<rect id="Rectangle_611" data-name="Rectangle 611" width="109" height="111.13"
										transform="translate(2553 -10654.13)" fill="#fff" />
									<g id="Group_5755" data-name="Group 5755">
										<path id="Path_1548" data-name="Path 1548"
											d="M728.533,1430.221H609.542V1311.092H728.533ZM618,1421.76H720.071V1319.553H618Z"
											transform="translate(1938.458 -11970.484)" fill="#1a1a1a" />
										<path id="Path_1549" data-name="Path 1549"
											d="M710.1,1303.65H654.243V1285.7a27.926,27.926,0,0,1,55.853,0Zm-47.392-8.46h38.931v-9.49a19.465,19.465,0,0,0-38.931,0Z"
											transform="translate(1925.327 -11954.56)" fill="#1a1a1a" />
									</g>
								</g>
							</g>
						</svg>
						<picture>
							<source media="(max-width: 767px)"
								:srcset="_.get(contentData, 'data.list[0].logo[0].devices.mobile')" />
							<source media="(max-width: 1023px)"
								:srcset="_.get(contentData, 'data.list[0].logo[0].devices.tablet')" />
							<img :src="_.get(contentData, 'data.list[0].logo[0].devices.desktop')" alt />
						</picture>
					</div>
					<div @click="changeMall(_.get(getData, 'another_store.url'))" class="mall flex pointer"
						v-if="_.get(getData, 'another_store.url')">
						<svg xmlns="http://www.w3.org/2000/svg" width="20.777" height="20.789"
							viewBox="0 0 20.777 20.789">
							<path id="Path_2842" data-name="Path 2842"
								d="M11.934-927.967v-18.427a1.2,1.2,0,0,1,1.154-1.151H31.5a1.214,1.214,0,0,1,1.214,1.214,1.213,1.213,0,0,1-.355.858l-7.1,7.1a1.213,1.213,0,0,1-.858.355,1.214,1.214,0,0,1-1.214-1.214v-2.751a1.212,1.212,0,0,0-.355-.85,1.214,1.214,0,0,0-1.717,0l-4.467,4.467a1.215,1.215,0,0,0,.007,1.71,1.213,1.213,0,0,0,.856.355h14.17a1.213,1.213,0,0,1,1.049,1.2,1.209,1.209,0,0,1-.342.844l-7.144,7.144a1.206,1.206,0,0,1-.843.342,1.214,1.214,0,0,1-1.214-1.209v-5.391l0,0a1.211,1.211,0,0,0-.355-.858,1.214,1.214,0,0,0-1.716,0l-7.1,7.1h0a1.213,1.213,0,0,1-.859.356,1.214,1.214,0,0,1-1.213-1.2"
								transform="translate(-926.768 -11.934) rotate(90)" fill="#fff" />
						</svg>

						{{
						$route.params.path1 == 'saburtalo'
						? $fn.tr('გლდანის ფილიალი')
						: $fn.tr('საბურთალოს ფილიალი')
						}}
					</div>
				</div>
				<div @click="back" class="back uppercase pointer">
					<svg xmlns="http://www.w3.org/2000/svg" width="7.857" height="10" viewBox="0 0 7.857 10">
						<path id="Icon_material-play-arrow" data-name="Icon material-play-arrow"
							d="M19.857,7.5v10L12,12.5Z" transform="translate(-12 -7.5)" fill="#fff" />
					</svg>
					{{ $fn.tr('უკან') }}
				</div>
			</div>
		</div>
		<div class="content-container">
			<div class="brand-inner__content container">
				<div class="row">
					<div class="title font-21 bold">
						{{ _.get(contentData, 'data.list[0].front_title') }}
					</div>
					<div class="categories">
						<div class="category-item" v-for="(cat, index) in categories" :key="index">
							{{ _.get(cat, 'title') + `${index == getFloor(categories).length - 1 ? '' : ','}` }}
						</div>
					</div>
					<div class="content-row">
						<div class="floor bold">
							{{ $fn.tr('სართული') + ': ' }}

							<span :key="indx"
								v-for="(item, indx) in getFloor(_.get(contentData, 'data.list[0].floor'))">{{
								_.get(item, 'title') +
								`${
								indx == getFloor(_.get(contentData, 'data.list[0].floor')).length - 1
								? ''
								: ','
								}`
								}}
							</span>
						</div>
						<a :href="_.get(contentData, 'data.list[0].url_360')" target="_blank"
							class="link-360 uppercase bold pointer">
							{{ $fn.tr("გალერეა") }} <span class="bold uppercase">360</span>
						</a>
					</div>
					<div class="desc text" v-html="_.get(contentData, 'data.list[0].description')"></div>
				</div>
				<div class="row brand-contact">
					<div class="contact-row" :key="indx" v-for="(item, indx) in contactInfo">
						<div class="title bold" v-if="item.content">{{ $fn.tr(item.title) }}:</div>
						<div class="content" v-html="item.content">{{ item.content }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="gallery">
			<div class="gallery__content container">
				<div class="gallery__title font-23 bold uppercase">
					{{ $fn.tr('გალერია') }}
				</div>
				<swiper ref="gallery" class="swiper-gallery" :options="swiperOptions">
					<swiper-slide class="single-slide active"
						v-for="(item, index) in _.get(contentData, 'data.list[0].gallery')" :key="index">
						<picture>
							<source media="(max-width: 767px)" :srcset="_.get(item, 'devices.mobile')" />
							<source media="(max-width: 1023px)" :srcset="_.get(item, 'devices.tablet')" />
							<img :src="_.get(item, 'devices.desktop')" alt />
						</picture>
						<div class="hover-logo" @click="activeSwiper(index)">
							<svg xmlns="http://www.w3.org/2000/svg" width="50" height="54" viewBox="0 0 50 54">
								<g id="Group_5899" data-name="Group 5899" transform="translate(-915.623 -1109.623)">
									<line id="Line_40" data-name="Line 40" y2="54"
										transform="translate(940.623 1109.623)" fill="none" stroke="#fff"
										stroke-width="5" />
									<line id="Line_41" data-name="Line 41" x1="50"
										transform="translate(915.623 1136.623)" fill="none" stroke="#fff"
										stroke-width="5" />
								</g>
							</svg>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<MapBlock :drop_down="true" :content="_.get(contentData, 'data.list[0]')" />
		<div class="offers" v-if="_.get(contentData, 'data.list[0].relations_data.offers')">
			<offers-slider :contentData="{
				data: {
					list: _.get(contentData, 'data.list[0].relations_data.offers'),
				},
				conf: {
					header: {
						title: _.get(contentData, 'data.list[0].offers_title'),
						full_list_title: _.get(contentData, 'data.list[0].offers_url.title'),
						full_list_url: _.get(contentData, 'data.list[0].offers_url.url'),
					},
					background: {
						white: true,
					},
				},
			}" />
		</div>
		<GalleryPopup @close="close" :images="_.get(contentData, 'data.list[0].gallery')" :imageId="selectedImage"
			:clickedIndex="clickedIndex" />
		<similar-brands v-if="_.get(contentData, 'data.list[0].relations_data.stores')" :contentData="{
			data: {
				list: _.get(contentData, 'data.list[0].relations_data.stores'),
			},
			conf: {
				header: {
					title: _.get(contentData, 'data.list[0].other_brands_title'),
					full_list_title: _.get(contentData, 'data.list[0].other_brands_url.title'),
					full_list_url: _.get(contentData, 'data.list[0].other_brands_url.url'),
				},
			},
		}" />
	</div>
</template>

<script>
import OffersSlider from './OffersSlider.vue';
import SimilarBrands from './SimilarBrands.vue';
import GalleryPopup from '../GalleryPopup.vue';
import BreadCrumb from '@/components/modules/BreadCrumb';
import MapBlock from '@/components/smartComponents/MapBlock';
export default {
	props: ['contentData'],
	components: {
		SimilarBrands,
		OffersSlider,
		GalleryPopup,
		BreadCrumb,
		MapBlock,
	},
	data() {
		return {
			mallRedirect: [],
			clickedIndex: 0,
			selectedImage: false,
			swiperOptions: {
				speed: 800,
				slidesPerView: 3,
				spaceBetween: 30,
				watchOverflow: true,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 5,
					},
					510: {
						slidesPerView: 2,
						spaceBetween: 15,
					},
					768: {
						slidesPerView: 2,
					},
					1023: {
						slidesPerView: 3,
					},
				},
			},
		};
	},
	computed: {
		contactInfo() {
			const address = _.get(
				this.$store.state.main.indx,
				`widgets.shops_contact_${this.$store.state.main.mallType}`
			);
			return [
				{
					title: 'mobile',
					content: _.get(this.contentData, 'data.list[0].phone'),
				},
				{
					title: 'workin hours',
					content: `${_.get(this.contentData, 'data.list[0].working_hours[0].hrs[0]')} - ${_.get(
						this.contentData,
						'data.list[0].working_hours[0].hrs[1]'
					)}`,
				},
				{
					title: 'address',
					content: _.get(this.contentData, 'data.list[0].alternate_address') || address.address,
				},
			];
		},
		getData() {
			return _.get(this.contentData, 'data.list.0')
		},
		categories() {
			return _.get(this.$store.state.main.indx, 'terms.store_categories').filter((cat) =>
				_.get(this.contentData, 'data.list[0].store_categories')?.includes(cat.id)
			);
		},
	},
	watch: {
		contentData: {
			immediate: true,
			handler(val) {
				if (val.data) {
					this.getMallData();
				}
			},
		},
	},
	methods: {
		activeSwiper(index) {
			this.clickedIndex = index;
			this.selectedImage = true;
		},
		close() {
			this.selectedImage = false;
			this.clickedIndex = 0;
		},
		back() {
			if (this.$route.fullPath?.includes('singleview')) {
				if (this.$route.params.path2 == 'singleview') {
					this.$router.push(
						`/${_.get(this.$store.state.main, 'indx.locale')}/${this.$route.params.path1}`
					);
				} else {
					this.$router.push(
						`/${_.get(this.$store.state.main, 'indx.locale')}/${this.$route.params.path1}/${this.$route.params.path2
						}`
					);
				}
			}
		},
		getFloor(floorId) {
			const floorWidget = this.$store.state.main?.indx?.terms?.floors;
			const res = [];
			_.size(floorId)
				? floorId.forEach((floor) => {
					res.push(floorWidget.find((item) => item.id == floor));
				})
				: '';
			return res;
		},
		changeMall(url) {
			this.$router.push(`/${_.get(this.$store.state.main, 'indx.locale')}/${url}`)
		},
		async getMallData() {
			// INDX data
			let AllProject = _.get(this.$store.state.main, 'indx.terms.project');
			let allStory = _.get(this.$store.state.main, 'indx.terms.store_types');

			// Current data
			let currentProject = _.get(this.contentData, 'data.list[0].project[0]');
			let currentStoryType = _.get(this.contentData, 'data.list[0].store_types[0]');

			// Filter
			let project = AllProject?.find((item) => item.id !== currentProject);
			// let getStoryType = allStory?.find(item => item.id !== currentStoryType);

			// Request data
			let params;
			params = {
				searchText: _.get(this.contentData, 'data.list[0].title'),
				contentType: _.get(this.contentData, 'data.list[0].content_type'),
				taxonomies: {
					project: [project?.id],
					store_types: [currentStoryType],
				},
			};
			const res = await this.$fn.postData('main/getDataList', params);

			this.mallRedirect = res?.data?.list;
		},
	},
};
</script>

<style lang="scss">
.brand-inner {
	&__cover {
		position: relative;
		width: 100%;
		height: 614px;

		@media (max-width: 767px) {
			height: 458px;
		}

		.img-box {
			position: relative;
			width: 100%;
			height: 614px;

			img {
				position: absolute;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			@media (max-width: 767px) {
				height: 458px;
			}
		}

		.layer {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			background: linear-gradient(to bottom, rgba(26, 26, 26, 0) 0%, rgba(26, 26, 26, 0.7) 100%);
		}

		.bottom-content {
			position: relative;

			.logo {
				position: absolute;
				bottom: -34px;
				display: flex;
				align-items: center;
			}

			.brand-logo {
				position: relative;

				img {
					position: absolute;
					left: 0;
					width: 70px;
					top: 50%;
					height: 40px;
					left: 50%;
					transform: translate(-50%, calc(-50% + 15px));
					object-fit: contain;
				}
			}

			.mall {
				margin-left: 30px;
				font-size: 13px;
				text-decoration: underline;
				color: $white;

				@media (max-width: 767px) {
					display: none;
				}

				svg {
					margin-right: 10px;
				}
			}

			.back {
				position: absolute;
				right: 0px;
				bottom: 30px;
				color: $white;

				@media (max-width: 1365px) {
					right: 53px;
				}
			}
		}
	}

	.content-container {
		position: relative;

		&:after {
			position: absolute;
			content: '';
			bottom: 0;
			width: 100%;
			height: 3px;
			background: linear-gradient(to right,
					#40adec 0%,
					#426ab3 20%,
					#3269e5 30%,
					#ffcb05 40%,
					#ffc900 50%,
					#ffc900 50%,
					#e11f26 60%,
					#e50b09 100%);
		}
	}

	&__content {
		padding-top: 69px;
		padding-bottom: 69px;
		padding-right: 60px;
		display: flex;
		justify-content: space-between;

		@media (max-width: 1365px) {
			padding-right: 0px;
		}

		@media (max-width: 1023px) {
			flex-direction: column;
			align-items: flex-start;
		}

		@media (max-width: 767px) {
			padding-right: 15px;
		}

		.row {
			&.brand-contact {
				height: fit-content;
			}

			width: 30vw;

			&:last-child {
				display: flex;
				padding-left: 80px;
				justify-content: space-between;
				flex-direction: column;

				@media (max-width: 1023px) {
					align-items: flex-start;
					width: 100%;
					padding-top: 38px;
					flex-direction: row;
					flex-wrap: wrap;
					padding-left: 0px;

					.contact-row {
						padding-right: 30px;
					}
				}
			}

			&:first-child {
				width: 70vw;
				position: relative;

				@media (max-width: 1023px) {
					width: 100%;
					padding-bottom: 38px;
				}

				&::after {
					position: absolute;
					right: -28px;
					content: '';
					width: 1px;
					height: 100%;
					background: rgba(77, 77, 79, 0.1);
					border-radius: 10px;
					top: 0;

					@media (max-width: 1023px) {
						top: unset;
						bottom: 0;
						width: 100%;
						height: 1px;
						left: 0;
					}
				}
			}

			.title {
				margin-bottom: 14px;
			}

			.categories {
				display: flex;
				flex-wrap: wrap;
				margin-bottom: 20px;

				.category-item {
					line-height: 24px;
					margin-right: 5px;
					color: #40adec;
					text-decoration: underline;
				}
			}

			.desc {
				line-height: 34px;
				color: #4d4d4f;
			}

			.content-row {
				display: flex;
				width: 268px;
				justify-content: space-between;
				margin-bottom: 34px;

				.link-360 {
					position: relative;
					color: unset;

					span {
						font-size: 11px;
						position: absolute;
					}
				}

				.floor {
					color: #4d4d4f;
					position: relative;

					// &::after {
					//   position: absolute;
					//   right: -38px;
					//   content: "";
					//   width: 1px;
					//   height: 30px;
					//   background: rgba(77, 77, 79, 0.1);
					// }
					span {
						&:last-child {
							i {
								display: none;
							}
						}
					}
				}
			}

			.contact-row {
				margin-bottom: 24px;

				.title {
					margin-bottom: 0px;
					color: #4d4d4f;
					line-height: 24px;
				}
			}
		}
	}

	.gallery {
		padding: 89px 0;
		background: #f7f7f7;

		@media (max-width: 767px) {
			padding: 55px 0 128px;
		}

		&__title {
			margin-bottom: 55px;

			@media (max-width: 1359px) {
				margin-bottom: 34px;
			}
		}

		.swiper-gallery {
			overflow: visible;

			.swiper-slide {
				height: 189px;
				position: relative;
				cursor: pointer;
				border: 5px solid;
				border-color: transparent;
				transition: 0.4s ease;

				&:hover {
					box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
					border-color: #ffcb05;

					.hover-logo {
						opacity: 1;
						visibility: visible;
					}
				}

				img {
					width: 100%;
					height: 100%;
					position: absolute;
					object-fit: cover;
				}

				.hover-logo {
					transition: 0.4s ease;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					opacity: 0;
					visibility: hidden;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		.swiper-gallery {
			overflow: visible;

			.swiper-slide {
				height: 189px;
				position: relative;
				cursor: pointer;
				border: 5px solid;
				border-color: transparent;
				transition: 0.4s ease;

				&:hover {
					box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
					border-color: #ffcb05;

					.hover-logo {
						opacity: 1;
						visibility: visible;
					}
				}

				img {
					width: 100%;
					height: 100%;
					position: absolute;
					object-fit: cover;
				}

				.hover-logo {
					transition: 0.4s ease;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					opacity: 0;
					visibility: hidden;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		.swiper-gallery {
			overflow: visible;

			.swiper-slide {
				height: 189px;
				position: relative;
				cursor: pointer;
				border: 5px solid;
				border-color: transparent;
				transition: 0.4s ease;

				&:hover {
					box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
					border-color: #ffcb05;

					.hover-logo {
						opacity: 1;
						visibility: visible;
					}
				}

				img {
					width: 100%;
					height: 100%;
					position: absolute;
					object-fit: cover;
				}

				.hover-logo {
					transition: 0.4s ease;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					opacity: 0;
					visibility: hidden;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		.swiper-gallery {
			overflow: visible;

			.swiper-slide {
				height: 189px;
				position: relative;
				cursor: pointer;
				border: 5px solid;
				border-color: transparent;
				transition: 0.4s ease;

				&:hover {
					box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
					border-color: #ffcb05;

					.hover-logo {
						opacity: 1;
						visibility: visible;
					}
				}

				img {
					width: 100%;
					height: 100%;
					position: absolute;
					object-fit: cover;
				}

				.hover-logo {
					transition: 0.4s ease;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					opacity: 0;
					visibility: hidden;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}
	}

	.height {
		min-height: 500px;
	}
}

.brand-inner {
	&__cover {
		position: relative;
		height: auto;
		padding-bottom: calc(100% / 3.14754098361);

		@media (max-width: 1919px) {
			padding-bottom: calc(100% / 3.14410480349);
		}

		@media (max-width: 1439px) {
			padding-bottom: calc(100% / 3.14746543779);
		}

		// @media (max-width: 1365px) {
		//   padding-bottom: calc(100% / 2.23580786026);
		// }
		@media (max-width: 1023px) {
			padding-bottom: calc(100% / 1.6768558952);
		}

		@media (max-width: 767px) {
			padding-bottom: calc(100% / 0.903930131004);
		}

		.bottom-content {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
		}

		.img-box {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;

			picture,
			img {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			img {
				object-fit: cover;
			}
		}
	}
}
</style>
